module.exports = __webpack_public_path__ + "0140092ea2fd419cb3748080e8e39a35.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-118.cur
// module id = 439
// module chunks = 0